import Axios from "axios";
const BASEURL = "https://wavepalmtechub.com";
export var baseUrl = "https://ajoo-server1.herokuapp.com/api/";
// export var baseUrl = "http://localhost:8080/api/";
export var imgUrl = "https://nimc-app.herokuapp.com/api";
// export var imgUrl = "http://localhost:3010/api";

const token = localStorage.getItem("token");

export var postData = (route, data) => {
  return new Promise((resolve, reject) => {
    Axios.post(baseUrl + route, data, {
      headers: {
        Authorization: `${token}`, // Assuming you're using Bearer token authentication
      },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getData = (route, data) => {
  return new Promise((resolve, reject) => {
    fetch(baseUrl + route, {
      method: "GET",
      headers: {
        Authorization: `${token}`,
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        console.error("error in post api", error);
        reject(error);
      });
  });
};

export var uploadFileService = (file) => {
  return new Promise((resolve, reject) => {
    try {
      const formData = new FormData();
      formData.append("photo", file);
      Axios.post(imgUrl + "/image-upload", formData)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          console.error("Error uploading file:", error);
        });
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
};

export const sendEmail = (URL, data) => {
  return new Promise((resolve, reject) => {
    fetch(BASEURL + URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        console.error("Error:", error);
        reject(error);
      });
  });
};
